// Import the functions you need from the SDKs you need
import { getAuth } from "firebase/auth"
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD9o8LEB_Jx99M2tqODyZbu7XJc7rCZzSI",
  authDomain: "netflix-gpt-ec15d.firebaseapp.com",
  projectId: "netflix-gpt-ec15d",
  storageBucket: "netflix-gpt-ec15d.firebasestorage.app",
  messagingSenderId: "242808899465",
  appId: "1:242808899465:web:496c3f3a469d1cd311c358",
  measurementId: "G-SD42P5FW88"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth=getAuth()